import React, { useState } from 'react';
// reactstrap components
import {
    FormGroup,
    Input,
    Row,
    Col,
} from "reactstrap";
import BasicModal from '../../../../components/Modals/BasicModal'
import {titleCase} from '../../../../utils/views/pages/Dynamics'

const CredentialTypeInformation = (props) => {
    const credentialType = props.credentialType
    const formDisabled = props.formDisabled
    const setCredentialType = props.setCredentialType
    const [showModal, setShowModal] = useState(false)
    const [warning, setWarning] = useState("")
    const validations = props.validations

    let validateField = (e) => {
        //console.log(!e.target.value.trim() && e.target.required)
        if (!e.target.value.trim() && e.target.required) {

            setWarning('The field \'' + titleCase(e.target.name) + '\' is required!')
            setShowModal(true)

        } else {
            if (validations[e.target.name] && !validations[e.target.name].test(e.target.value)) {                
                setWarning('Invalid ' + titleCase(e.target.name))
                setShowModal(true)
            }
        }

    }

    let handleInput = (e) => {
        
        credentialType[e.target.name] = e.target.value
        setCredentialType(credentialType)

    }

    return (
        <>
            <h6 className="heading-small text-muted mb-4">
                Credential Type information
            </h6>
            <div className="pl-lg-4">
                <Row>                           
                    <Col lg="12">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-name"
                            >
                                Name
                            </label>
                            <Input
                                className="form-control-alternative"
                                defaultValue={credentialType?.name}
                                id="input-name"
                                name="name"
                                placeholder="Credential Type Name"
                                type="text"
                                disabled={formDisabled}
                                onChange={handleInput}
                                required={true}
                                onBlur={validateField}
                            />
                        </FormGroup>
                    </Col>                     
                </Row>

            </div>

            <BasicModal
                title="Warning"
                message={warning}
                showModal={showModal}
                setShowModal={setShowModal} />
        </>
    )
}

export default CredentialTypeInformation;